<div id="home"></div>
<!-- start: Loading Spinner-->
<div *ngIf="loading" class="loading-spinner-container">
    <mat-spinner class="loading-spinner"></mat-spinner>
</div>
<!-- end: Loading Spinner-->

<!-- start: templateContainer-->
<!-- <div [id]="i" [ngClass]="isEven(i) ? 'secondary-bg' : 'primary-bg'"> -->
<div id="glb-container" class="primary-bg">
    <ng-template #templateContainer></ng-template>
    <div id='form-container'></div>
</div>
<div *ngIf="openCookieConsent" class="cookieConsentContainer">
    <div class="cookieConsent">
        <span>This website uses cookies to ensure you get the best experience.</span>
        <span class="button-allow" (click)='closeSnackBar()'>Allow Cookies</span>
    </div>
</div>
<!-- end: templateContainer -->